export default "__VITE_ASSET__Ch1NVogU__"